import React,{ Component } from 'react';
import { StyleModal } from './style'
import ExternalIcon from '../../ExternalIcon';
import { IMG } from '../../../themes';

export class ModalShowImage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpenModalShowImage: this.props.isOpenModalShowImage,
    };
  }
  handleOpen = () => {
    this.setState({ isOpenModalShowImage: true });
  };
  handleClose = () => {
    this.setState({ isOpenModalShowImage: false });
  };
  render() {
    const { isOpenModalShowImage } = this.state;
    const { colorTheme, img, isError, label = 'User Manual' } = this.props;
    
    if (isOpenModalShowImage) {
      return (
        <StyleModal colorTheme={colorTheme}>
          <div className='modal-container'>
            <div className='modal-overlay' onClick={this.handleClose}></div>
            <div className={`${isError ? 'modal-content error': 'modal-content'}`}>
              <button onClick={this.handleClose} className='close-button'>
                <img src={IMG['ic_x.svg']} className='x-button'/>
              </button>
              <img alt='' src={img} className={`${isError ? 'image-error' : 'modal-image'}`}/>
            </div>
          </div>
        </StyleModal>
      );
    }
    return (
      <StyleModal colorTheme={colorTheme}>
        <button onClick={this.handleOpen} className='link-button'>
          <span className='link-text'>{label}</span>
          <ExternalIcon color={colorTheme} width={16} height={16} style={{ transform: 'translateY(2px)' }} />
        </button>
      </StyleModal>
    );
  }
}
